import { Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { useGetDashboardPermissionsQuery } from "web_myplann/Api/Calculators/useGetDashboardPermissionsQuery";
import { DashboardPicturedRow } from "web_myplann/Dashboard/Components/DashboardPictureRow";
import { DashboardSkeleton } from "web_myplann/Dashboard/Components/DashboardSkeleton";
import { useOpenCalculator } from "web_myplann/Dashboard/Hooks/useOpenCalculator";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import mortgageImg from "web_myplann/Shared/Assets/mortgage.png";
import travelImg from "web_myplann/Shared/Assets/travel.png";
import { NavigationTypes } from "web_myplann/Utils/device";

const PageResources = Resources.Dashboard.ImageCard;

export const DashboardImageCardSection: FC = () => {
	const { t } = useResource();
	const { data: permissions, isLoading: isPermissionsLoading } =
		useGetDashboardPermissionsQuery();
	const { openCalculator, isOpeningCalculator } = useOpenCalculator();

	return (
		<Stack px={1.6} pt={1.6}>
			{!isPermissionsLoading && (
				<Typography variant="deprecatedH3">{t(PageResources.title)}</Typography>
			)}
			{isPermissionsLoading ? (
				<Stack pt={1.2}>
					<DashboardSkeleton height={80} count={2} />
				</Stack>
			) : (
				<Stack
					alignItems="center"
					pt={1.2}
					gap={1.2}
					data-testid="dashboard-image-card"
				>
					<DashboardPicturedRow
						title={t(PageResources.Mortgage.title)}
						description={t(PageResources.Mortgage.description)}
						imageSrc={mortgageImg}
						onClick={() =>
							openCalculator(NavigationTypes.MortgageCalculatorScreen)
						}
						disabled={!permissions?.mortgage || isOpeningCalculator}
					/>
					<DashboardPicturedRow
						title={t(PageResources.Travel.title)}
						description={t(PageResources.Travel.description)}
						imageSrc={travelImg}
						onClick={() =>
							openCalculator(NavigationTypes.TravelInsuranceCalculatorScreen)
						}
						disabled={!permissions?.travelInsurance || isOpeningCalculator}
					/>
				</Stack>
			)}
		</Stack>
	);
};
